import {createSlice} from '@reduxjs/toolkit';
import {createSelector} from 'reselect';
import {PATIENT_FHIR_ID, ORGANIZATION_FHIR_ID} from '../../constants';

export const searchFormSlice = createSlice({
  name: 'searchForm',
  initialState: {
    inputData: '',
    inputDataType: PATIENT_FHIR_ID,
    searchPerformedOn: '',
    optionalOrganizationSearchParameter: '',
    optionalOrganizationSearchParameterType: ORGANIZATION_FHIR_ID,
    isOrganizationSearchParameterShown: true,
    isOrganizationSearchParameterBarOpened: false
  },
  reducers: {
    setInputData: (state, action) => {
      state.inputData = action.payload;
    },
    setInputDataType: (state, action) => {
      state.inputDataType = action.payload;
    },
    setSearchPerformedOn: (state, action) => {
      state.searchPerformedOn = action.payload;
    },
    setOptionalOrganizationSearchParameter: (state, action) => {
      state.optionalOrganizationSearchParameter = action.payload;
    },
    setOptionalOrganizationSearchParameterType: (state, action) => {
      state.optionalOrganizationSearchParameterType = action.payload;
    },
    setIsOrganizationSearchParameterShown: (state, action) => {
      state.isOrganizationSearchParameterShown = action.payload;
    },
    setIsOrganizationSearchParameterBarOpened: (state, action) => {
      state.isOrganizationSearchParameterBarOpened = action.payload;
    }
  }
});

export const {
  setInputData,
  setInputDataType,
  setSearchPerformedOn,
  setOptionalOrganizationSearchParameter,
  setOptionalOrganizationSearchParameterType,
  setIsOrganizationSearchParameterShown,
  setIsOrganizationSearchParameterBarOpened
} = searchFormSlice.actions;

const searchFormSelector = (state) => state.searchForm;

export const inputDataSelector = createSelector([searchFormSelector], (searchFormData) => searchFormData.inputData);
export const inputDataTypeSelector = createSelector(
  [searchFormSelector],
  (searchFormData) => searchFormData.inputDataType
);
export const searchPerformedOnSelector = createSelector(
  [searchFormSelector],
  (searchFormData) => searchFormData.searchPerformedOn
);
export const optionalOrganizationSearchParameterSelector = createSelector(
  [searchFormSelector],
  (searchFormData) => searchFormData.optionalOrganizationSearchParameter
);
export const optionalOrganizationSearchParameterTypeSelector = createSelector(
  [searchFormSelector],
  (searchFormData) => searchFormData.optionalOrganizationSearchParameterType
);
export const isOrganizationSearchParameterShownSelector = createSelector(
  [searchFormSelector],
  (searchFormData) => searchFormData.isOrganizationSearchParameterShown
);
export const isOrganizationSearchParameterBarOpenedSelector = createSelector(
  [searchFormSelector],
  (searchFormData) => searchFormData.isOrganizationSearchParameterBarOpened
);

export default searchFormSlice.reducer;
